"use strict";

function last(a) {
  return a[a.length - 1];
}

function first(a) {
  return a[0];
}

module.exports = {
  last: last,
  first: first
};


//////////////////
// WEBPACK FOOTER
// ./~/docxtemplater/js/utils.js
// module id = 238
// module chunks = 2